import { ImageBackground, StyleSheet, View, ViewProps } from "react-native";

import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { PdText, tPdText } from ".";
import { PdIconButton, tPdIconButtonProps } from "../forms/icon-button";
import { SLImage, tReactiveImageProps } from "../ReactiveImage";

export const PdProfileBanner: React.FC<ViewProps> = ({ style, ...rest }) => (
  <ImageBackground
    source={{ uri: "/images/profile-banner.png" }}
    resizeMode="cover"
    style={[styles.pdProfileBanner, style]}
    {...rest}
  />
);

export const PdProfileAvatar: React.FC<tReactiveImageProps> = ({ mobileStyle, webStyle, ...rest }) => (
  <SLImage
    mobileStyle={[styles.pdProfileAvatar, mobileStyle]}
    webStyle={{ ...webStyles.pdProfileAvatar, ...webStyle }}
    {...rest}
  />
);

export const PdProfileCard: React.FC<ViewProps> = ({ style, ...rest }) => (
  <View style={[styles.pdProfileCard, style]} {...rest} />
);

export const PdProfileSocialIconButton: React.FC<tPdIconButtonProps> = ({ contentContainerStyle, ...rest }) => {
  return <PdIconButton contentContainerStyle={[styles.pdProfileSocialButton, contentContainerStyle]} {...rest} />;
};

export const PdProfileTag: React.FC<ViewProps> = ({ style, ...rest }) => (
  <View style={[styles.pdProfileTag, style]} {...rest} />
);

export const PdProfileTagLabel: React.FC<tPdText> = ({ style, ...rest }) => (
  <PdText style={[styles.pdProfileTagLabel, style]} {...rest} />
);

const styles = StyleSheet.create({
  pdProfileAvatar: {
    alignSelf: "center",
    backgroundColor: kColors.gray400,
    borderColor: kColors.white,
    borderRadius: 999,
    borderWidth: 4,
    height: 180,
    marginTop: -12 * kStyleConst.kSpacing,
    width: 180,
  },
  pdProfileBanner: {
    backgroundColor: kColors.brandGreen,
    height: 200,
    width: "100%",
  },
  pdProfileCard: {
    backgroundColor: kColors.lightGray,
    borderRadius: 8,
    padding: 8 * kStyleConst.kSpacing,
    width: "100%",
  },
  pdProfileSocialButton: {
    borderRadius: 999,
    borderWidth: 1,
    height: 25,
    width: 25,
  },
  pdProfileTag: {
    backgroundColor: kColors.brand400,
    borderRadius: 6,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    paddingVertical: 1 * kStyleConst.kSpacing,
  },
  pdProfileTagLabel: {
    color: kColors.white,
    fontSize: 12,
    fontWeight: "400",
  },
});

const webStyles: { [key: string]: React.CSSProperties } = {
  pdProfileAvatar: {
    alignSelf: "center",
    backgroundColor: kColors.gray400,
    borderColor: kColors.white,
    borderRadius: 999,
    borderWidth: 4,
    height: 180,
    marginTop: -12 * kStyleConst.kSpacing,
    width: 180,
  },
} as const;
